import { createContext, useContext } from 'react';
import { isCalendarPage } from '../../../utils/presets';
import { Preset } from '../../../types/types';

export const PresetContext = createContext<Preset>(Preset.CALENDAR_PAGE);

export const PresetConsumer = PresetContext.Consumer;
export const PresetProvider = PresetContext.Provider;

export const usePreset = () => {
  const preset = useContext(PresetContext);

  return {
    isCalendarPage: isCalendarPage(preset),
  };
};
